import { Field, Form, Formik } from 'formik';
import { Col, Row } from 'reactstrap';

import useAuth from '../../../Hooks/useAuth';
import { Btn } from '../../../AbstractElements';
import { CustomDatePiker } from '../../../components/common/Form/CustomDatePiker';
import { FormikCurrencyInput } from '../../../components/ui/form/FormikCurrencyInput';
import { FormikInput } from '../../../components/ui/form/FormikInput';
import { FormikNumberInput } from '../../../components/ui/form/FormikNumberInput';
import { FormikSelect } from '../../../components/ui/form/FormikSelect';
import { loanRequestFormSchema } from '../validations/loanRequestFormSchema';
import { useCreateLoanRequest } from '../../../services/mutations/useCreateLoanRequest';
import { useLoanRequest } from '../../../Hooks/LoanRequest/useLoanRequest';
import { useNavigate } from 'react-router-dom';

export const LoanRequestForm = () => {
   const { user } = useAuth();
   const loanRequest = useLoanRequest();
   const createLoanRequest = useCreateLoanRequest();
   const navigate = useNavigate();

   return (
      <Formik
         initialValues={loanRequest.selector.form}
         validationSchema={loanRequestFormSchema(
            loanRequest.query.data?.credit_limit || 0
         )}
         onSubmit={(values, { resetForm }) => {
            createLoanRequest.mutate(
               {
                  userId: user?.id!,
                  requestDate: values.disbursement!,
                  requestAmount: values.value!,
                  period: values.period!,
                  frequency: values.frequency!,
                  description: values.description,
                  bankId: +values.bank!,
                  accountNumber: +values.account!,
                  accountType: values.typeAccount!,
               },
               {
                  onSuccess: () => {
                     loanRequest.actions.setDefault();
                     resetForm();
                     navigate('/');
                  },
               }
            );
         }}
      >
         {({ handleSubmit, values }) => {
            {
               loanRequest.actions.setForm(values);
            }
            return (
               <Col xl={6} sm={12}>
                  <Form onSubmit={handleSubmit}>
                     <h5 className="mb-3">Formulario de solicitud</h5>
                     <Row>
                        <Col md={6}>
                           <Field
                              label="Fecha de desembolso"
                              name="disbursement"
                              placeholder="Desembolso"
                              component={CustomDatePiker}
                              minDate={new Date()}
                           />
                        </Col>
                     </Row>

                     <Row>
                        <Col md={6}>
                           <FormikCurrencyInput
                              name="value"
                              label="Monto"
                              placeholder="Ingresa el monto"
                              className="rounded-lg"
                           />
                        </Col>
                        <Col md={6}>
                           <FormikSelect
                              name="period"
                              label="Periodo"
                              options={loanRequest.frequencyOptions}
                           />
                        </Col>
                     </Row>

                     <Row>
                        <Col md={12}>
                           <FormikSelect
                              name="frequency"
                              label="Frecuencia"
                              options={[
                                 { label: 'Quincenal', value: 'FORTNIGHTLY' },
                                 { label: 'Mensual', value: 'MONTHLY' },
                              ]}
                           />
                        </Col>
                     </Row>

                     <Row>
                        <Col md={12}>
                           <FormikInput
                              name="description"
                              label="Información adicional"
                              placeholder="Ingrese información adicional"
                              type="textarea"
                           />
                        </Col>
                     </Row>

                     <h5 className="mb-3">Información de desembolso </h5>

                     <Row>
                        <Col md={6}>
                           <FormikSelect
                              name="bank"
                              label="Banco"
                              placeholder="Seleccione un banco"
                              options={loanRequest.query.data?.banks || []}
                           />
                        </Col>

                        <Col md={6}>
                           <FormikNumberInput
                              name="account"
                              label="Número de cuenta"
                              type="bank-account"
                              placeholder="Ingresa número de cuenta"
                              className="rounded-lg"
                           />
                        </Col>
                     </Row>

                     <Row>
                        <FormikSelect
                           name="typeAccount"
                           label="Tipo de cuenta"
                           placeholder="Seleccione un tipo de cuenta"
                           options={[
                              { value: 'AHORRO', label: 'Ahorro' },
                              { value: 'CREDITO', label: 'Credito' },
                           ]}
                        />
                     </Row>

                     <Row>
                        <Col md={12} className="text-end mt-3 mb-3">
                           <Btn
                              type="submit"
                              color="primary"
                              disabled={createLoanRequest.isPending}
                           >
                              {createLoanRequest.isPending
                                 ? 'Enviando...'
                                 : 'Solicitar préstamo'}
                           </Btn>
                        </Col>
                     </Row>
                  </Form>
               </Col>
            );
         }}
      </Formik>
   );
};
